<script setup>
import { formatBytes, get } from '@/common/util'
import { Chart, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title } from 'chart.js'
import _ from 'lodash-es'
import { reactive } from 'vue'
import { Doughnut } from 'vue-chartjs'
Chart.register(ArcElement, CategoryScale,LinearScale,PointElement,LineElement,BarElement, Tooltip, Legend,Title)
const meta=reactive({datatypes:['apiintegration','layers','styles','roadview','roadview_notes']})
,init=async()=>{
  let res=await get('rest/authed/admin/storageinfo')
  const sd={labels:['freeSpace','usingSpace'],datasets:[{backgroundColor: ['#41B883', '#E46651'],data:[]}],sizes:{}}
  _.entries(res.data).forEach(ent=>sd.sizes[ent[0]]=formatBytes(ent[1]).join(' '))
  sd.labels.forEach(key=>sd.datasets[0].data.push(formatBytes(res.data[key],'MB')))
  meta.storagedata=sd

  meta.datasize={
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
      {
        label: 'Data One',
        backgroundColor: '#f87979',
        data: [40, 39, 10, 40, 39, 80, 40]
      }
    ]
  }
  meta.datastatus={
    labels: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    datasets: [
      {
        label: 'Data One',
        backgroundColor: '#f87979',
        data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
      }
    ]
  }
}
init()
</script>
<template>
  <v-row>
    <v-col>
      <v-card class="ma-1">
        <v-card-title class="text-center">
          {{ $t('servertotaldiskcapacity') }}
        </v-card-title>
        <v-divider/>
        <v-card-text v-if="meta.storagedata">
          <Doughnut :data="meta.storagedata" :options="{responsive:false,maintainAspectRatio: true}" style="margin:auto;"/>
          <div>{{ $t('servertotaldiskcapacity') }}:{{ meta.storagedata.sizes.totalSpace }}</div>
          <div>{{ $t('usageamount') }}:{{ meta.storagedata.sizes.usingSpace }}</div>
          <div>{{ $t('remainingamount') }}:{{ meta.storagedata.sizes.freeSpace }}</div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col>
      <v-card class="ma-1">
        <v-card-title class="text-center">
          {{ $t('servermonitoring') }}
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row>
            <v-col>DB</v-col>
            <v-col cols="1"><v-icon icon="mdi-lightbulb-on"/></v-col>
          </v-row>
          <v-row>
            <v-col>지도서버</v-col>
            <v-col cols="1"><v-icon icon="mdi-lightbulb-on"/></v-col>
          </v-row>
          <v-row>
            <v-col>길찾기서버</v-col>
            <v-col cols="1"><v-icon icon="mdi-lightbulb-on"/></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
